<template>
<div>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
            <v-flex xs12 sm12 md11>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2 header">
                            <v-flex xs6 sm7>
                                <p class="text-color">Edit User</p><p class="err">{{ error }}</p>
                            </v-flex>

                        </v-layout>
                        <v-layout row wrap>
                            <v-flex sm12 md12>
                                <v-form id="update_user"
                                 @submit.prevent="updateUser" 
                                 data-vv-scope="updateUser"
                                 autocomplete="off"
                                  ref="user_form" v-model="valid">
                                    <v-card-text>
                                        <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                                           
                                            
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                    <v-text-field 
                                                    name="User Name" 
                                                    label="Username" 
                                                    id="User Name" 
                                                    v-model="user_object.username">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                    <v-text-field 
                                                    name="Password" 
                                                    label="Password" 
                                                    id="password" 
                                                    v-model="user_object.password">
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                    <v-autocomplete :items="role_list" name="Role" :disabled="true" v-model="user_object.role_id" return-object label="Roles" item-text="display_name" item-value="id" clearable>
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" small :loading="loading" :disabled="loading" type="submit">Update</v-btn>
                                        <v-btn text small to="/users">Cancel</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
    watch: {
        "user_object.first_name": {
            deep: true,
            handler(val) {
                if (val) {
                    this.user_object.first_name = val.charAt(0).toUpperCase() + val.slice(1);
                }

            }
        },
        "user_object.last_name": {
            deep: true,
            handler(val) {
                if (val) {
                    this.user_object.last_name = val.charAt(0).toUpperCase() + val.slice(1);
                }

            }
        },
        "user_object.role_id": {
            deep: true,
            handler(val) {
                if (val) {
                    if (val.name == 'office_admin') {
                        this.is_office_admin = true;
                    } else {
                        this.is_office_admin = false;
                    }
                    

                }

            }
        },
    },
    methods: {
        getofficeList() {
            this.is_loading = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/offices`).then((response) => {
                if (response.data.status == 1) {
                    this.office_list = response.data.office_list.data;
                    this.is_loading = false;

                }
                 if(response.data.status == 0){
                    this.error = "Error Occured - Unable to fetch data";
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
        validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },
        updateUser: function () {
            this.loaders.submit_loader = true;
           
            axios.post(`${process.env.VUE_APP_API_URL}/api/users/` + this.$route.params.id + `/update`, this.user_object).then((response) => {
                if (response.data.status == 1) {
                    this.$router.push({
                        name: 'showUserDetails',
                        params: {
                            id: response.data.user.id,
                        success_message:'User Updated Successfully'
                    
                        }
                    });
                    this.loaders.submit_loader = false;
                }
                if(response.data.status == 0){
                    this.error = "Error Occured";
                }
            }).catch((error) => {
                console.log(error);
            }).finally(() => {

            });
        },
        getUserDetails: function () {
            this.loaders.detail_loader = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/users/` +
                    this.$route.params.id + `/edit`
                )
                .then(response => {
                    if (response.data.status == 1) {
                        this.user_object = response.data.user;
                        this.loaders.detail_loader = false;

                    }
                     if(response.data.status == 0){
                    this.error = "Error Occured - Unable to get data";
                }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },
        getRoleList: function () {

            this.role = localStorage.getItem('visitor_management_role');
            if (this.role == "Office Admin") {
                this.role_list = [{
                    'name': 'office_admin',
                    'display_name': 'Office Admin',
                    'id': '2'
                }];

            } else if (this.role == "Society Admin") {

                this.role_list = [{
                        'name': 'reception_user',
                        'display_name': 'Reception User',
                        'id': '3'
                    },
                    {
                        'name': 'super_admin',
                        'display_name': 'Society Admin',
                        'id': '1'
                    },
                    {
                        'name': 'office_admin',
                        'display_name': 'Office Admin',
                        'id': '2'
                    }
                ];

            } else if (this.role == "Super Admin") {

                this.role_list = [{
                        'name': 'reception_user',
                        'display_name': 'Reception User',
                        'id': '3'
                    },
                    {
                        'name': 'office_admin',
                        'display_name': 'office Admin',
                        'id': '2'
                    },
                    {
                        'name': 'super_admin',
                        'display_name': 'Super Admin',
                        'id': '1'
                    },
                    //  {   'name':'society_admin','display_name':'Society Admin','id':'4'} 
                ];
            }
        }
    },
    data: () => {
        return {
            error:'',
            user_object: {
                first_name: '',
                last_name: '',
                email: '',
                mobile: '',
                username: '',
                employee_id: '',
                password: '',
                office_id: '',
                role: '',
            },
            office_list: [],
            loaders: {
                detail_loader: false,
                submit_loader: false,
            },
            role_list: [],
            loading: false,
            is_office_admin: false,
            loader: null,
            wings_list: [],

            valid: false,

        }
    },
    mounted() {
        this.getUserDetails();
        this.getRoleList();
        this.getofficeList();
    },
};
</script>

<style scoped>
.theme--light.v-card {
    background-color: #FFFFFF;
    color: rgba(0, 0, 0, 0.87);
    padding: 4% 4% 3% 3%;
}
</style>
